<template>
    <div class="layout-topbar">
        <div class="topbar-left">
            <a tabindex="0" class="menu-button" @click="onMenuButtonClick">
                <i class="pi pi-chevron-left"></i>
            </a>

            <router-link to="/" class="horizontal-logo">
                <img id="logo-horizontal" class="horizontal-logo" src="layout/images/logo-white.svg" alt="diamond-layout" />
            </router-link>

            <span class="topbar-separator"></span>

            <div class="layout-breadcrumb viewname" style="text-transform: uppercase">
                <template v-if="$route.meta.breadcrumb">
                    <span>{{$route.meta.breadcrumb[0].label}}</span>
                </template>
            </div>

            <img id="logo-mobile" class="mobile-logo" src="layout/images/logo-dark.svg" alt="diamond-layout" />
        </div>

        <AppMenu :model="menu" :layoutMode="layoutMode" :active="menuActive" :mobileMenuActive="staticMenuMobileActive"
            @menu-click="onMenuClick" @menuitem-click="onMenuItemClick" @root-menuitem-click="onRootMenuItemClick"></AppMenu>

        <div class="layout-mask modal-in"></div>

        <div class="topbar-right">
            <ul class="topbar-menu">
                <li class="search-item">
                    <a tabindex="0" @click="onSearchClick">
                        <i class="pi pi-search"></i>
                    </a>
                </li>
                <li class="notifications-item" :class="{ 'active-menuitem ': topbarNotificationMenuActive }">
                    <a href="#" tabindex="0" @click="onTopbarNotificationMenuButtonClick">
                        <i class="pi pi-bell"></i>
                        <!-- <span class="topbar-badge">5</span> -->
                    </a>
                    <ul class="notifications-menu fade-in-up">
                        <li role="menuitem">
                            <span style="color: #495057;padding: 0.5rem;display: -ms-flexbox;display: flex;-ms-flex-align: center;align-items: center;border-radius: 4px;transition: background-color 0.2s;">
                                <i class="pi pi-check-square"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Non ci sono nuove notifiche</div>
                                    <div class="notification-detail"></div>
                                </div>
                            </span>
                        </li>
                        <!-- 
                        <li role="menuitem">
                            <a href="#" tabindex="0">
                                <i class="pi pi-shopping-cart"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Nuovo Ordine</div>
                                    <div class="notification-detail">Hai <strong>3</strong> nuovi ordini.</div>
                                </div>
                            </a>
                        </li>
                        <li role="menuitem">
                            <a href="#" tabindex="0">
                                <i class="pi pi-chart-line"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Report mensili</div>
                                    <div class="notification-detail">Nuovi report disponibili.</div>
                                </div>
                            </a>
                        </li>
                        <li role="menuitem">
                            <a href="#" tabindex="0">
                                <i class="pi pi-comments"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Commenti</div>
                                    <div class="notification-detail"><strong>2</strong> nuovi commenti.</div>
                                </div>
                            </a>
                        </li>
                        <li role="menuitem">
                            <a href="#" tabindex="0">
                                <i class="pi pi-exclamation-circle"></i>
                                <div class="notification-item">
                                    <div class="notification-summary">Richiesta di rimborso</div>
                                    <div class="notification-detail"><strong>1</strong> da controllare.</div>
                                </div>
                            </a>
                        </li>
                         -->
                    </ul>
                </li>

                <li style="border-right: none;" class="profile-item" :class="{ 'active-menuitem fadeInDown': topbarUserMenuActive }">
                    <a href="#" @click="onTopbarUserMenuButtonClick">
                        <i class="pi pi-user"></i>&nbsp;<span class="profile-name">{{ operatorName }}</span>
                    </a>
                    <ul class="profile-menu fade-in-up">
                        <li>
                            <a @click="onProfileClick()">
                                <i class="pi pi-user"></i>
                                <span>Profilo</span>
                            </a>
                        </li>
                        <li>
                            <a @click="onSettingsClick($event)">
                                <i class="pi pi-cog"></i>
                                <span>Impostazioni</span>
                            </a>
                        </li>
                        <li>
                            <a @click="logout">
                                <i class="pi pi-power-off"></i>
                                <span>Logout</span>
                            </a>
                        </li>
                    </ul>
                </li>

                <!--
                <li class="right-sidebar-item">
                    <a href="#" tabindex="0" @click="onRightMenuClick">
                        <i class="pi pi-align-right"></i>
                    </a>
                </li>
                -->
            </ul>
        </div>
    </div>
</template>

<script>
import AppMenu from "./AppMenu";

export default {
    name: "AppTopbar",
    emits: ["menu-click", "menuitem-click", "root-menuitem-click",
            "menu-button-click", "search-click", "topbar-notification",
            "topbar-user-menu", "right-menubutton-click", "settings-click",
            "logout-click"
           ],
    props: {
        topbarNotificationMenuActive: Boolean,
        topbarUserMenuActive: Boolean,
        layoutMode: String,
        menu: Array,
        menuActive: Boolean,
        staticMenuMobileActive: Boolean
    },
    data() {
        return {
            items: []
        };
    },
    computed: {
        operatorName(){
            return this.$store.getters.operator
        }
    },
    components: {
        AppMenu
    },
    unmounted() {
        if (this.subscription) {
            this.subscription.unsubscribe();
        }
    },
    methods: {
        onProfileClick() {
            this.$router.replace({ name: 'profile' });
        },
        onSettingsClick(event) {
            this.$emit("settings-click", event);
        },
        onMenuClick(event) {
            this.$emit("menu-click", event);
        },
        onMenuItemClick(event) {
            this.$emit("menuitem-click", event);
        },
        onRootMenuItemClick(event) {
            this.$emit("root-menuitem-click", event);
        },
        onMenuButtonClick(event) {
            this.$emit("menu-button-click", event);
        },
        onSearchClick(event) {
            this.$emit("search-click", event);
        },
        onTopbarNotificationMenuButtonClick(event) {
            this.$emit("topbar-notification", event);
        },
        onTopbarUserMenuButtonClick(event) {
            this.$emit("topbar-user-menu", event);
        },
        onRightMenuClick(event) {
            this.$emit("right-menubutton-click", event);
        },
        isMobile() {
            return window.innerWidth <= 1091;
        },
        logout() {
            this.$emit('logout-click');
        }
    }
};
</script>
